import { api } from "./api";

interface GetShowResultsRequest {
  date?: Temporal.PlainDate | null;
  showTypeId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export const getShowResults = async ({
  date,
  showTypeId,
  search,
  page = 0,
  pageSize = 25,
}: GetShowResultsRequest): Promise<any> => {
  const params = new URLSearchParams();
  if (date) params.append("date", date.toString());
  if (showTypeId) params.append("showTypeId", encodeURIComponent(showTypeId));
  if (search) params.append("search", search);
  params.append("page", page.toString());
  params.append("pageSize", pageSize.toString());
  const url = `/showresults`;
  const { data } = await api.get<object>(
    params ? `${url}?${params.toString()}` : url
  );

  return data;
};

export default {
  getShowResults,
};
